import { Injectable } from '@angular/core';
import { Api } from '../../contracts/classes/api.class';
import { Observable } from 'rxjs';
import { IResponse } from '../../contracts/models/response.model';
import { CreateTypeAddressDTO, TypeAddress, updateOrderTypeAddressDTO, UpdateTypeAddressDTO } from '../../contracts/models/type-address.model';

@Injectable({
  providedIn: 'root'
})
export class TypeAddressService extends Api {
  
  getAll(): Observable<IResponse<TypeAddress[]>> {
    return this.http.get<IResponse<TypeAddress[]>>(`${this.url}/tipoDireccion`);
  }

  create(createTypeEmailDTO: CreateTypeAddressDTO): Observable<IResponse<TypeAddress>> {
    return this.http.post<IResponse<TypeAddress>>(`${this.url}/tipoDireccion`, createTypeEmailDTO);
  }

  update(UpdateTypeAddressDTO: UpdateTypeAddressDTO): Observable<IResponse<TypeAddress>> {
    return this.http.put<IResponse<TypeAddress>>(`${this.url}/tipoDireccion/${UpdateTypeAddressDTO.id}`, UpdateTypeAddressDTO);
  }

  delete(id: number): Observable<IResponse<TypeAddress>> {
    return this.http.delete<IResponse<TypeAddress>>(`${this.url}/tipoDireccion/${id}`);
  }

  updateOrder(updateOrderTypeAddressDTO: updateOrderTypeAddressDTO[]): Observable<IResponse<TypeAddress[]>> {
    return this.http.put<IResponse<TypeAddress[]>>(`${this.url}/tipoDireccion/data/updateOrder`, {
      tipoDirecciones: updateOrderTypeAddressDTO
    });
  }
}
